import { kmsClient } from 'api/apollo';
import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { CREATIVE_IMAGES_QUERY } from './creativeImages';
import { CreativeImages, CreativeImagesVariables } from './__generated__/CreativeImages';

export const useCreativeImagesQuery = (variables: CreativeImagesVariables) => {
  return useQuery<CreativeImages>(CREATIVE_IMAGES_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
  });
};

export const useCreativeImagesLazyQuery = (variables: CreativeImagesVariables) => {
  return useLazyQuery<CreativeImages>(CREATIVE_IMAGES_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
